import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66de54e8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\moyongpeng-project\\tianyi-crm\\scrm-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66de54e8')) {
      api.createRecord('66de54e8', component.options)
    } else {
      api.reload('66de54e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=66de54e8", function () {
      api.rerender('66de54e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fwpt/profile/index.vue"
export default component.exports